import { TooltipText } from '@app/core';
import { ReactElement } from 'react';

interface Props {
  title?: string;
  hide?: boolean;
  children: ReactElement;
}

export const OptionalTooltip = ({ title, hide, children }: Props) =>
  hide ? children : <TooltipText title={title}>{children}</TooltipText>;
